import { HttpContextToken } from '@angular/common/http';

/**
 * Set to `true` on requests that must bypass the Cognito auth interceptor — e.g. unauthenticated
 * auth calls (login, forgot-password) and direct-to-S3 presigned PUT/GET uploads, where attaching
 * our Bearer token would be wrong (S3 rejects a request that carries BOTH a query-param signature
 * and an `Authorization` header).
 *
 * Lives in `core-data` (`type:data`) so both `auth` (the interceptor) and data-access services can
 * reference the SAME token instance — the interceptor matches on identity, so a duplicate token
 * defined in another lib would not be recognized.
 *
 * Usage:
 * ```ts
 * this.http.put(presignedUrl, file, {
 *   context: new HttpContext().set(SKIP_INTERCEPTOR, true),
 * });
 * ```
 */
export const SKIP_INTERCEPTOR = new HttpContextToken<boolean>(() => false);
